import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import FormSpinner from 'components/FormSpinner';
import { useDispatch } from 'react-redux';
import { getAttachmentById } from '../../../services/attachmentService';
import { IMAGE_MIME_TYPES } from '../../../constants/imageMimeTypes';
import { LEADING_DOT_REGEX } from '../../../constants/regex';
import { executeApiAction } from '../../../utility/apiHelper';

const AttachmentImagePreview = ({ attachment }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const attachmentId = attachment.ptsAttachmentID;
  const fileType = String(attachment.FileType || attachment.FileName?.split('.').pop() || '')
    .toLowerCase()
    .replace(LEADING_DOT_REGEX, '');
  const mimeType = IMAGE_MIME_TYPES[fileType] || (fileType.startsWith('image/') ? fileType : null);

  useEffect(() => {
    if (!attachmentId || !mimeType) return;

    let active = true;
    let objectUrl;
    setPreviewUrl(null);
    setFailed(false);

    executeApiAction({
      dispatch,
      action: () => getAttachmentById(attachmentId),
      setLoading: (value) => {
        if (active) setLoading(value);
      },
      onSuccess: (response) => {
        if (!active) return;
        const fileObject = response?.[0]?.FileObject;
        if (fileObject == null) {
          setFailed(true);
          return;
        }
        const bytes = fileObject?.data || fileObject;
        const buffer = Array.isArray(bytes) ? new Uint8Array(bytes) : bytes;
        objectUrl = URL.createObjectURL(new Blob([buffer], { type: mimeType }));
        setPreviewUrl(objectUrl);
      },
      onError: () => {
        if (active) setFailed(true);
      },
    });

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attachmentId, mimeType, dispatch]);

  if (!mimeType) return null;
  if (loading) return <FormSpinner />;
  if (failed) {
    return (
      <Box mb={3} mt={1}>
        <Typography variant="body2" color="textSecondary">
          Image preview is unavailable.
        </Typography>
      </Box>
    );
  }
  if (!previewUrl) return null;

  return (
    <Box className="attachment-image-preview">
      <Box
        component="img"
        src={previewUrl}
        alt={attachment.FileName || 'Attachment preview'}
        onError={() => setFailed(true)}
        className="attachment-image-preview__image"
      />
    </Box>
  );
};

export default AttachmentImagePreview;
